import accountPlan from './moduleAccountPlan'
export default accountPlan
